import { render, staticRenderFns } from "./brand-owner.vue?vue&type=template&id=9f234036&scoped=true&"
import script from "./brand-owner.vue?vue&type=script&lang=js&"
export * from "./brand-owner.vue?vue&type=script&lang=js&"
import style0 from "./brand-owner.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./brand-owner.vue?vue&type=style&index=1&id=9f234036&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f234036",
  null
  
)

export default component.exports